import { render, staticRenderFns } from "./OfficialPerson.vue?vue&type=template&id=60889f46&scoped=true"
import script from "./OfficialPerson.vue?vue&type=script&lang=js"
export * from "./OfficialPerson.vue?vue&type=script&lang=js"
import style0 from "./OfficialPerson.vue?vue&type=style&index=0&id=60889f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60889f46",
  null
  
)

export default component.exports